module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/contact_collector-4d7456233e33a710a455432d1459a62c.jpg";